
import { ChevronDownIcon, ChevronUpIcon } from '@vue-hero-icons/outline'
import { DTDropdownItemInjector } from '../../keys'
import {
  computePosition,
  flip,
  shift,
  offset,
  autoUpdate,
} from '@floating-ui/dom'

export default {
  components: { ChevronDownIcon, ChevronUpIcon },
  provide() {
    return {
      [DTDropdownItemInjector]: {
        toggle: this.toggle,
        el: () => this.$el,
      },
    }
  },
  props: {
    text: {
      type: String,
      default: '',
    },
    alignBody: {
      type: String,
      default: 'left',
      validator: (val) => ['left', 'center', 'right'].includes(val),
    },
    iconClass: {
      type: [String, Array, Object],
      default: null,
    },
    menuClass: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    open: {
      type: Boolean,
      default: false,
    },
    flip: {
      type: Boolean,
      default: false,
    },
    dropup: {
      type: Boolean,
      default: false,
    },
    boundary: {
      type: Function,
      default: () => ({}),
    },
    offset: {
      type: Number,
      default: 8,
    },
  },
  data() {
    return {
      localOpen: false,
      cleanupMethod: undefined,
    }
  },
  computed: {
    placement() {
      switch (this.alignBody) {
        case 'right':
          return this.dropup ? 'top-end' : 'bottom-end'
        case 'center':
          return this.dropup ? 'top' : 'bottom'
        default:
        case 'left':
          return this.dropup ? 'top-start' : 'bottom-start'
      }
    },
  },
  watch: {
    open: {
      immediate: true,
      handler(isOpen) {
        this.localOpen = isOpen
      },
    },
    localOpen(isOpen) {
      this.$emit('update:open', isOpen)
      if (isOpen) {
        this.$nextTick(() => {
          this.setupAutoUpdate()
        })
      } else {
        this.cleanupMethod?.()
      }
    },
  },
  mounted() {
    document.addEventListener('click', this.handleClickOutside)
  },
  destroyed() {
    document.removeEventListener('click', this.handleClickOutside)
    this.cleanupMethod?.()
  },
  methods: {
    setupAutoUpdate() {
      this.cleanupMethod = autoUpdate(
        this.$refs.trigger,
        this.$refs.container,
        () => this.calculatePosition(),
      )
    },
    async calculatePosition() {
      const boundary = await this.boundary()
      const { x, y } = await computePosition(
        this.$refs.trigger,
        this.$refs.container,
        {
          placement: this.placement,
          middleware: [
            offset(this.offset),
            flip ? flip() : () => ({}),
            shift({
              altBoundary: true,
              boundary:
                Object.keys(boundary).length > 0 &&
                boundary instanceof HTMLElement
                  ? boundary
                  : undefined,
            }),
          ],
        },
      )
      Object.assign(this.$refs.container.style, {
        transform: `translate3d(${Math.round(x)}px,${Math.round(y)}px,0)`,
      })
    },
    handleClickOutside(event) {
      if (this.localOpen && !this.$el.contains(event.target)) {
        this.localOpen = false
      }
    },
    toggle() {
      this.localOpen = !this.localOpen
    },
  },
}
